import { rgba } from '../../../lib/helpers'
import { theme } from '../../../theme'

import type { Styles } from 'react-modal'

const baseOverlayStyles = {
  border: 'none',
  background: rgba(theme.colors.sapphireDark, 0.6),
  outline: 'none',
  zIndex: 101,
}

export const asideInlineStyles: Styles = {
  overlay: {
    ...baseOverlayStyles,
    height: '100vh',
  },
  content: {
    top: 0,
    left: 0,
    height: '100vh',
    border: 'none',
    borderRadius: '0',
    outline: 'none',
    maxWidth: '1180px',
    padding: 0,
  },
}

export const defaultInlineStyles: Styles = {
  overlay: {
    ...baseOverlayStyles,
  },
  content: {
    position: 'relative',
    width: '90%',
    borderRadius: '14px',
    inset: 0,
    overflowY: 'scroll',
    scrollbarWidth: 'none',
    maxHeight: 'max-content',
    height: '96%',
  },
}
